export const DeleteUserTemplate = `
<ul class="add-user__users">
  <li class="add-user__empty" style="display: none">No users in this chat</li>
</ul>
{{{deleteFromChatButton}}}
`;
